var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0859 46.1719C36.2837 46.1719 46.1719 36.2837 46.1719 24.0859C46.1719 11.8882 36.2837 2 24.0859 2C11.8882 2 2 11.8882 2 24.0859C2 36.2837 11.8882 46.1719 24.0859 46.1719Z",
    stroke: "url(#paint0_linear_3739_1833)",
    strokeWidth: 2.8653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9333 17C18.9104 17 19.7025 17.7921 19.7025 18.7692V20.4682C19.7025 21.4453 18.9104 22.2374 17.9333 22.2374C16.9562 22.2374 16.1641 21.4453 16.1641 20.4682V18.7692C16.1641 17.7921 16.9562 17 17.9333 17ZM29.8259 17C30.8031 17 31.5952 17.7921 31.5952 18.7692V20.4682C31.5952 21.4453 30.8031 22.2374 29.8259 22.2374C28.8488 22.2374 28.0567 21.4453 28.0567 20.4682V18.7692C28.0567 17.7921 28.8488 17 29.8259 17Z",
    fill: "url(#paint1_linear_3739_1833)",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4766 30.8099C11.4766 29.1564 13.8039 25.8211 14.8652 24.3755C15.1259 24.0259 15.6472 24.0259 15.9079 24.3755C16.9692 25.8211 19.2966 29.1564 19.2966 30.8099C19.2966 32.9548 17.5464 34.6933 15.3866 34.6933C13.2268 34.6933 11.4766 32.9548 11.4766 30.8099Z",
    fill: "url(#paint2_linear_3739_1833)",
    fillOpacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7545 33.4748C28.8321 30.7984 25.532 29.6976 22.5176 30.4453",
    stroke: "url(#paint3_linear_3739_1833)",
    strokeOpacity: 0.9,
    strokeWidth: 2.76,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3739_1833",
    x1: 9.60336,
    y1: -0.896517,
    x2: 52.508,
    y2: 66.0854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145833,
    stopColor: "#F3696E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A902"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3739_1833",
    x1: 23.5469,
    y1: 19.5294,
    x2: 23.6765,
    y2: 22.9817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A902"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3739_1833",
    x1: 15.218,
    y1: 29.2228,
    x2: 16.2396,
    y2: 36.0539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A902"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3739_1833",
    x1: 26.4775,
    y1: 31.9213,
    x2: 29.822,
    y2: 35.2711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A902"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCry);
export default __webpack_public_path__ + "static/media/cry.b2d9642a2c8aef7c35ad7c8cdc23fbea.svg";
export { ForwardRef as ReactComponent };